import { render, staticRenderFns } from "./OpenFileInfo.vue?vue&type=template&id=d3396f00&scoped=true&"
import script from "./OpenFileInfo.vue?vue&type=script&lang=js&"
export * from "./OpenFileInfo.vue?vue&type=script&lang=js&"
import style0 from "./OpenFileInfo.vue?vue&type=style&index=0&id=d3396f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3396f00",
  null
  
)

export default component.exports